<div class="px-3">

  <div class="rem-text-default mb-6">
    <div class="flex align-items-end">

      <div class="rem-bg-light px-3 py-3 mr-2">
        <i class="pi pi-users font-medium text-xl"></i>
      </div>
      <div>
        <div class="text-2xl font-medium">Notification Contacts</div>
        <div class="text-right mt-2">Manage notification contacts</div>
      </div>
      
    </div>
  </div>


 <div class="flex justify-content-between">
    <div class="flex flex-row gap-3">
      <creditor-autocomplete
        (onSelect)="onSelectCreditor($event)"
      ></creditor-autocomplete>

       <remitter-button
          (click)="search()" 
          label='Get'
          icon='search'
        >     
        </remitter-button>
    </div>

    <remitter-button   
      (click)="onOpenSideBar()" 
      label='Add New'
      icon='plus'
      severity='info'
    >     
    </remitter-button>
</div>
<div class="mt-4">
     <div 
     *ngIf="!hasTableData && hasClickedSearch"
      style="text-align:center; margin-top:9rem; color: #336699; font-size: 1rem;">
                    🚫 No records found for {{ creditorCompanyName }}
      </div>

    <p-table
        *ngIf="hasTableData"
        [value]="notificationContacts" [paginator]="true"
                                           [rows]="5"
                                           [tableStyle]="{ 'min-width': '50rem' }"
                                           [rowsPerPageOptions]="[5, 10, 20]">
        <ng-template pTemplate="header">
            <tr class="text-xs">
                <th>Notification Contact Id</th>
                <th>Email</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Action</th>               
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-contact>
            <tr class="text-xs">
                <td>{{ contact.NotificationContactId }}</td>
                <td>{{ contact.Email }}</td>
                <td>{{ contact.FirstName }}</td>
                <td>{{ contact.LastName }}</td>       
                <td>
                    <div class="flex align-items-center">
                        <icon-button
                          pTooltip='Edit'
                          tooltipPosition='left'
                          (click)="onOpenSideBar(contact.NotificationContactId, contact.FirstName, contact.LastName, contact.Email)"
                          [icon]="'pencil'"
                          [styleClass]="'mr-1'"
                        />

                        <icon-button
                          pTooltip='Delete'
                          tooltipPosition='left'
                          (click)="onOpenDeleteModal(contact)"
                          [icon]="'trash'"
                        />
                        
                      </div>
                </td>       
            </tr>
        </ng-template>
    </p-table>
</div>

</div>

<common-delete-modal 
  [(visible)]="isDeleteModalVisible" 
  message="Are you sure you want to delete this Notification Contact?" 
  width="30vw"
  (actionClicked)="onConfirmDelete()">
</common-delete-modal>

<p-sidebar [(visible)]="isSideBarVisible" styleClass="w-4" position="right">
    <div class="bg-white shadow-3 border-round p-4">
      <div class="text-xl font-medium">{{false? 'Edit ' : 'Add New '}} Notification Contact</div>
      <input type="text" pInputText  class="w-full mt-4" placeholder="First Name" [(ngModel)]="firstName" />
      <input type="text" pInputText  class="w-full mt-2" placeholder="Last Name" [(ngModel)]="lastName"/>
      <input type="text" pInputText  class="w-full mt-2" placeholder="Email" [(ngModel)]="email"/>
      <div class="flex justify-content-end mt-4">
        <remitter-button
          (click)="onSave()" 
          label='Save'
          icon='send'
        >     
        </remitter-button>
      </div>
    </div>
</p-sidebar>
